module.exports = __webpack_public_path__ + "img/57.d5ed6140.jpg";